import { render, staticRenderFns } from "./LeaveGuardComponent.vue?vue&type=template&id=02337220&scoped=true"
import script from "./LeaveGuardComponent.vue?vue&type=script&lang=js"
export * from "./LeaveGuardComponent.vue?vue&type=script&lang=js"
import style0 from "./LeaveGuardComponent.vue?vue&type=style&index=0&id=02337220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02337220",
  null
  
)

export default component.exports